<template lang="pug">
  extends ../tool/CommonDetail.pug
  block detail
    ListFormuleLines(:parent_id="this.$route.params.id" @success="success" @error="error")
</template>

<script>
  import CommonDetail from "../tool/CommonDetail.js"
  
  import {Model, EditDialog} from "./imports.js"

  import ListFormuleLines from "../formuleline/ListFormuleLines.vue"


  export default {
    extends: CommonDetail,
    components: {
       ListFormuleLines, Infos: EditDialog
    },
    props: {
    },
    computed: {
    },
    watch: {
    }, 
    data: () => ({
    }),

    methods: {
      loadModel () {
        this.model = new Model()
      },
    },
  }

</script>
